import { render, staticRenderFns } from "./BaseCardPostSchedule.vue?vue&type=template&id=76281962&scoped=true&"
import script from "./BaseCardPostSchedule.vue?vue&type=script&lang=js&"
export * from "./BaseCardPostSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardPostSchedule.vue?vue&type=style&index=0&id=76281962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76281962",
  null
  
)

export default component.exports